import { useState } from 'react';
import { useApp } from '../App';
import api from '../api';
import { useI18n } from '../i18n/index.jsx';

export default function Onboarding() {
  const { user, setUser, setPage } = useApp();
  const { t } = useI18n();
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({
    first_name: user?.first_name || '',
    last_name: user?.last_name || '',
    date_of_birth: '',
    citizenship: '',
    passport_number: '',
    phone: '',
    email: '',
    address_street: '',
    address_city: '',
    address_zip: '',
  });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  function upd(k, v) { setForm({ ...form, [k]: v }); }

  async function saveAndContinue() {
    setSaving(true); setMsg('');
    try {
      const { data } = await api.put('/me', form);
      setUser(data);
      if (step === 0) {
        setStep(1);
      } else {
        await api.post('/me/submit');
        setUser({ ...data, profile_status: 'pending' });
        setPage('dashboard');
      }
    } catch (e) {
      setMsg('❌ ' + (e.response?.data?.detail || e.message));
    }
    setSaving(false);
  }

  function skip() { setPage('dashboard'); }

  if (step === 0) return (
    <div className="page onboarding">
      <div className="onboarding-header">
        <div className="onboarding-icon">👋</div>
        <h1>Добро пожаловать!</h1>
        <p>Заполните основные данные для начала работы</p>
      </div>
      <div className="form">
        <div className="field"><label>Имя *</label>
          <input value={form.first_name} onChange={e => upd('first_name', e.target.value)} placeholder="Ваше имя" /></div>
        <div className="field"><label>Фамилия *</label>
          <input value={form.last_name} onChange={e => upd('last_name', e.target.value)} placeholder="Ваша фамилия" /></div>
        <div className="field"><label>Дата рождения</label>
          <input type="date" value={form.date_of_birth} onChange={e => upd('date_of_birth', e.target.value)} /></div>
        <div className="field"><label>Гражданство</label>
          <input value={form.citizenship} onChange={e => upd('citizenship', e.target.value)} placeholder="Например: Украина" /></div>
        <div className="field"><label>Телефон *</label>
          <input type="tel" value={form.phone} onChange={e => upd('phone', e.target.value)} placeholder="+48..." /></div>
        <div className="field"><label>{t('common.email')}</label>
          <input type="email" value={form.email} onChange={e => upd('email', e.target.value)} placeholder="email@example.com" /></div>
      </div>
      {msg && <div className="message">{msg}</div>}
      <div className="actions">
        <button className="btn btn-primary" onClick={saveAndContinue} disabled={saving || !form.first_name || !form.last_name}>
          {saving ? '...' : 'Далее →'}
        </button>
        <button className="btn btn-link" onClick={skip}>Заполню позже</button>
      </div>
    </div>
  );

  return (
    <div className="page onboarding">
      <div className="onboarding-header">
        <div className="onboarding-icon">📋</div>
        <h1>Дополнительные данные</h1>
        <p>Для оформления документов</p>
      </div>
      <div className="form">
        <div className="field"><label>Номер паспорта</label>
          <input value={form.passport_number} onChange={e => upd('passport_number', e.target.value)} /></div>
        <div className="field"><label>Адрес (улица)</label>
          <input value={form.address_street} onChange={e => upd('address_street', e.target.value)} placeholder="ул. Варшавская 10/5" /></div>
        <div className="field"><label>Город</label>
          <input value={form.address_city} onChange={e => upd('address_city', e.target.value)} placeholder="Warszawa" /></div>
        <div className="field"><label>Индекс</label>
          <input value={form.address_zip} onChange={e => upd('address_zip', e.target.value)} placeholder="00-000" /></div>
      </div>
      {msg && <div className="message">{msg}</div>}
      <div className="actions">
        <button className="btn btn-primary" onClick={saveAndContinue} disabled={saving}>
          {saving ? '...' : '✅ Отправить на проверку'}
        </button>
        <button className="btn btn-link" onClick={skip}>Заполню позже</button>
      </div>
    </div>
  );
}
